/* @flow */

const costCentreRoutes = {
  assignedUsersToContract: '/assets/account/:accountId/user/:userId/contract/:contractId',
  activity: 'cost-centres/:contractId/activity',
};

export default costCentreRoutes;
